<template>
  <b-container fluid align="center">
    <h2 class="align-self-center mt-5">{{ formData.opportunity_name }}</h2>
    <iframe-integration
      :app="app"
      :path="path"
      :params="params"
    ></iframe-integration>
  </b-container>
</template>

<script>
import IframeIntegration from '@gid/vue-common/components/IframeIntegration';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  components: {
    IframeIntegration,
  },
  data() {
    return {
      app: 'order-intake-forms',
      path: `/`,
    };
  },
  computed: {
    params() {
      return new URLSearchParams({
        locale: 'de',
        opportunity: this.formData.opportunity,
        form: this.formData.id,
        resize: 'true',
      });
    },
  },
};
</script>
